/**
 * Created by mykurisu on 2018/4/8.
 */
import React from 'react'
import {connect} from 'react-redux'
import {isPC} from '../../utils'
import '../../css/page/MainPage.css';


class MainNewNav extends React.Component {
    constructor() {
        super()
        this.state = {
            navTop: 44,
            navPosition: 'relative',
            categoryList: [],
            categorySelected: 0,
            subCategoryList: [],
            subCategorySelected: null,
        }
    }

    componentDidMount() {
        let list = this.props.category
        let obj = {
            parent_id: null,
            sub_category: [],
            name: "推荐",
            id: 0
        }
        list.unshift(obj)
        this.setState({
            categoryList: list
        })

        let cache = window.sessionStorage.getItem('newSelectedCategory')
        if (cache) {
            for (let i = 0;i < list.length;i++) {
                for (let j = 0;j < list[i].sub_category.length;j++) {
                    if (list[i].sub_category[j].id === Number(cache)) {
                        this.setState({
                            categorySelected: list[i].id,
                            subCategoryList: list[i].sub_category,
                            subCategorySelected: list[i].sub_category[j].id
                        })
                        break
                    }
                }
            }
        }

        this.scroll_method = () => {
            this.handleMoveAnimation()
        };

        window.addEventListener('scroll', this.scroll_method);
    }

    componentWillUnmount() {
        this.scroll_method && window.removeEventListener('scroll', this.scroll_method);
    }

    handleMoveAnimation() {
        let main = document.querySelector('.main-page')
        let allScrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
        if (allScrollTop > 50) {
            if (this.state.navPosition === 'relative') {
                if (this.state.categorySelected === 0) {
                    main.style.paddingTop = '44px'
                }else {
                    main.style.paddingTop = '88px'
                }
                this.setState({
                    navPosition: 'fixed'
                })
            }
        } else {
            if (this.state.navPosition === 'fixed') {
                main.style.paddingTop = '0'
                this.setState({
                    navPosition: 'relative'
                })
            }
        }
    }

    handleCategorySelect(e,item) {
        let changeState = {
            categorySelected: Number(item.id),
            subCategoryList: item.sub_category,
            subCategorySelected: null
        }
        if (item.sub_category.length > 0) {
            changeState.subCategorySelected = Number(item.sub_category[0].id)
        }
        if (!changeState.subCategorySelected && changeState.categorySelected !== 0) {
            let sub  = this.props.mineCategories
            let subSelected = sub.find(item => item.parent_id === changeState.categorySelected)
            changeState.subCategorySelected = Number(subSelected.id)
        }
        this.handldSliderMove(e)
        this.setState(changeState,() => {
            let subCategorySelected = this.state.subCategorySelected
            if (this.state.categorySelected === 0) {
                subCategorySelected = 0
                this.setState({
                    subCategorySelected: null
                })
            }
            this.context.mainPage.loadData(subCategorySelected);
            this.context.page.showToast('加载中', 'loading', false);
            this.props.dispatch({
                type: 'MAIN_SELECT_CATEGORY',
                payload: subCategorySelected
            })
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        })
    }

    handleSubCategorySelect(item) {
        let changeState = {
            subCategorySelected: Number(item.id),
        }
        this.setState(changeState, () => {
            let subCategorySelected = this.state.subCategorySelected
            if (!subCategorySelected && this.state.categorySelected !== 0) {
                return
            }
            if (this.state.categorySelected === 0) {
                subCategorySelected = 0
                this.setState({
                    subCategorySelected: null
                })
            }
            this.context.mainPage.loadData(subCategorySelected);
            this.context.page.showToast('加载中', 'loading', false);
            this.props.dispatch({
                type: 'MAIN_SELECT_CATEGORY',
                payload: subCategorySelected
            })
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        })
    }

    handldSliderMove(e) {
        let ulContainer = document.querySelector('.top__container');
        ulContainer.scrollLeft = e.clientX + ulContainer.scrollLeft - (document.documentElement.clientWidth / 2) + 20;
    }

    render() {
        return (
            <div className="main__newnav" style={{position: this.state.navPosition}}>
                <div className="newnav__top" style={{height: isPC() ? '54px' : '44px'}}>
                    <div className="top__container">
                        <div className="container__wrap">
                            {this.state.categoryList.map(item => {
                                return(
                                    <div key={'c' + item.id}
                                         onClick={(e) => this.handleCategorySelect(e, item)}
                                         className={this.state.categorySelected === item.id ? 'wrap__item wrap__item-active' : 'wrap__item'}
                                         data-id={item.id}
                                    >
                                        {item.name}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>

                {this.state.subCategoryList && this.state.subCategoryList.length > 0 &&
                <div className="newnav__sub" style={{height: isPC() ? '54px' : '44px'}}>
                    <div className="sub__container">
                        <div className="container__wrap">
                            {this.state.subCategoryList.map(item => {
                                return (
                                    <div key={'s' + item.id}
                                         onClick={() => this.handleSubCategorySelect(item)}
                                         className="wrap__item">
                                        <div className={this.state.subCategorySelected === item.id ? 'item__text-active' : 'item__text'}>
                                            {item.name}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                }
            </div>
        )
    }
}

MainNewNav.contextTypes = {
    mainPage: React.PropTypes.object,
    page: React.PropTypes.object
}

export default connect(state => ({
    category: state.main.category.data.all,
    mineCategories: state.main.category.data.subd,
}))(MainNewNav)



// WEBPACK FOOTER //
// ./src/components/main/MainNewNav.js